/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationMetric } from './EvaluationMetric';
import {
    EvaluationMetricFromJSON,
    EvaluationMetricFromJSONTyped,
    EvaluationMetricToJSON,
} from './EvaluationMetric';

/**
 * 
 * @export
 * @interface EvaluationMetricsResponse
 */
export interface EvaluationMetricsResponse {
    /**
     * 
     * @type {Array<EvaluationMetric>}
     * @memberof EvaluationMetricsResponse
     */
    metrics: Array<EvaluationMetric>;
}

/**
 * Check if a given object implements the EvaluationMetricsResponse interface.
 */
export function instanceOfEvaluationMetricsResponse(value: object): value is EvaluationMetricsResponse {
    if (!('metrics' in value) || value['metrics'] === undefined) return false;
    return true;
}

export function EvaluationMetricsResponseFromJSON(json: any): EvaluationMetricsResponse {
    return EvaluationMetricsResponseFromJSONTyped(json, false);
}

export function EvaluationMetricsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationMetricsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'metrics': ((json['metrics'] as Array<any>).map(EvaluationMetricFromJSON)),
    };
}

export function EvaluationMetricsResponseToJSON(value?: EvaluationMetricsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'metrics': ((value['metrics'] as Array<any>).map(EvaluationMetricToJSON)),
    };
}

